export const hexToRgb = (hex: string): string => {
  const stripped = hex.replace('#', '').trim();
  const normalized =
    stripped.length === 3
      ? stripped
          .split('')
          .map((c) => c + c)
          .join('')
      : stripped;
  if (!/^[a-f\d]{6}$/i.test(normalized)) return '';
  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  return `${r}, ${g}, ${b}`;
};
